import { useContext } from "react";
import { Button } from "reactstrap";
import { SegmentContext } from "./SegmentContext";

const DemoOpenSegment = () => {
  const currentSegmentContext = useContext(SegmentContext);

  return (
    <>
      <Button onClick={currentSegmentContext.toggleModalVisibility}>
        Toggle visibility
      </Button>
    </>
  );
};

export default DemoOpenSegment;
